import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PermissionService } from '../services/permission.service';

/**
 * Guard basado en permisos (no en roles).
 *
 * Uso en rutas:
 * ```ts
 * {
 *   path: 'imports',
 *   canActivate: [permissionGuard],
 *   data: { permissions: ['operations:view'] },
 * }
 * ```
 * Si `data.permissions` está vacío o no se define, el guard permite el acceso.
 * Si el usuario no tiene ninguno de los permisos requeridos, redirige a /app/dashboard.
 */
export const permissionGuard: CanActivateFn = (route) => {
  const permService = inject(PermissionService);
  const router      = inject(Router);

  const required: string[] = route.data?.['permissions'] ?? [];

  if (required.length === 0 || permService.hasAny(required)) {
    return true;
  }

  return router.createUrlTree(['/app/dashboard']);
};
